/**
 * An order's shipping_address is stored as one string, "street, city" — the
 * order form joins the two fields that way and splits them back at the
 * LAST comma (a street often contains commas of its own).
 */
export function splitShippingAddress(full: string | null | undefined): { street: string; city: string } {
    const text = (full ?? "").trim();
    const lastComma = text.lastIndexOf(",");
    if (lastComma === -1) return { street: text, city: "" };
    return { street: text.slice(0, lastComma).trim(), city: text.slice(lastComma + 1).trim() };
}

export function joinShippingAddress(street: string, city: string): string {
    return `${street.trim()}, ${city.trim()}`;
}
